<template lang="html">
    <div class="guarantee-detail preview">
        <MyTitle theTitle="解保详情"/>
            <div class="fd-com-scroll">
                <Slogan theTitle="解保审查信息"/>
                <div ref="jbscxx">
                    <!--财产线索-->
                    <div v-if="jcbqjbxxData.nBqlx == '1'">
                        <van-swipe-cell
                            v-for="(item, index) in jcbqccxsData"
                            :key="item.cId">
                            <van-cell
                                title='财产类型'
                                :value=item.cCclx
                                :key="item.cId"
                                @click="goToScxxDeatil(item, item.cId, index)"
                            ></van-cell>
                        </van-swipe-cell>
                    </div>

                    <!--证据信息-->
                    <div v-if="jcbqjbxxData.nBqlx == '2'">
                        <van-swipe-cell v-for="(item, index) in jcbqzjxxData" :key="item.cid">
                            <van-cell
                                title='证据类型'
                                :value=item.nZjlx
                                :key="item.cid"
                                @click="goToScxxDeatil(item, item.cid, index)"
                            ></van-cell>
                        </van-swipe-cell>
                    </div>

                    <!--行为信息-->
                    <div v-if="jcbqjbxxData.nBqlx == '3'">
                        <van-swipe-cell
                            v-for="(item, index) in jcbqxwxxData"
                            :key="item.cid">
                            <van-cell
                                title='行为类型'
                                :value=item.nXwbqsx
                                :key="item.cId"
                                @click="goToScxxDeatil(item, item.cId, index)"
                            ></van-cell>
                        </van-swipe-cell>
                    </div>
                </div>
                <Slogan theTitle="基本信息"/>
                <!--        保全-执行信息预览 -->
                <div ref="jcbqjbxx">
                    <van-field
                        v-model="jcbqjbxxData.cSqfymc"
                        readonly
                        label="姓名"
                    ></van-field>
                    <van-field
                        v-model="jcbqjbxxData.cAh"
                        readonly
                        label="案号"
                    ></van-field>
                    <van-field
                        label="申请人"
                        readonly
                        v-model="jcbqjbxxData.cSqrmcs"
                    ></van-field>
                    <van-field
                        v-model="jcbqjbxxData.cJcbqsy"
                        readonly
                        label="解除保全事由"
                    ></van-field>
                    <van-field
                        v-model="jcbqjbxxData.cTjrsf"
                        readonly
                        label="提交人身份"
                    ></van-field>
                    <van-field
                        v-model="jcbqjbxxData.dtCreatetime"
                        readonly
                        label="创建申请日期"
                    ></van-field>
                    <van-field
                        v-model="jcbqjbxxData.cBz"
                        label="备注"
                        readonly
                    ></van-field>
                </div>

                <!--财产线索-->
                <div v-if="jcbqjbxxData.nBqlx == '1'">
									 <Slogan theTitle="财产线索"/>
                    <!-- <info-title title-content="财产线索"></info-title> -->
                    <van-swipe-cell
                        v-for="item in jcbqccxsData"
                        :key="item.cId">
                        <van-cell
                            title='财产类型'
                            :value=item.cCclx
                            :key="item.cId"
                        ></van-cell>
                    </van-swipe-cell>
                </div>

                <!--证据信息-->
                <div v-if="jcbqjbxxData.nBqlx == '2'">
                    <Slogan theTitle="证据信息"/>
                    <van-swipe-cell v-for="item in jcbqzjxxData" :key="item.cId">
                        <van-cell
                            title='证据类型'
                            :value=item.nZjlx
                            :key="item.cId"
                        ></van-cell>
                    </van-swipe-cell>
                </div>

                <!--行为信息-->
                <div v-if="jcbqjbxxData.nBqlx == '3'">
                    <Slogan theTitle="行为信息"/>
                    <van-swipe-cell
                        v-for="item in jcbqxwxxData"
                        :key="item.cid">
                        <van-cell
                            title='行为类型'
                            :value=item.nXwbqsx
                            :key="item.cId"
                        ></van-cell>
                    </van-swipe-cell>
                </div>
                <Slogan theTitle="上传材料"/>
                <div class="fd-upload-wrap">
                    <ac-preview-file
                        title="解除保全申请书"
												class="pt0"
                        :data="sqsclList"></ac-preview-file>
                    <ac-preview-file
                        title="其他材料"
												class="pt0"
                        :data="sqsclListQtcl"></ac-preview-file>
                </div>
            </div>
        </div>
</template>

<script>
import Slogan from "@/components/common/slogan";
import MyTitle from "../../components/common/myTitle";
// import acUploadFile from '@/components/app/continuation-upload-file/index.vue';
// 预览文件
import acPreviewFile from "@/components/app/preview-file/index.vue";
import { mapGetters } from "vuex";
import { getJcbqScclList, getJcbqxx } from "@/api/guarantee";
import {zjlxType, typeJcbqsy, xwsxType, typeCclx, typeTjrlx} from "@/filters";

export default {
  data() {
    return {
      active: 0,
      cId: this.$route.query.cId,
      sqsclList: [],
      sqsclListQtcl: [],
      // 解除保全基本信息
      jcbqjbxxData: {
        cSqfymc: "",
        cAh: "",
        cSqrxm: "",
        cJcbqsy: "",
        cTjrsf: "",
        dtCreatetime: "",
        cBz: "",
        nBqlx: "",
      },
    };
  },
  // 依赖
  provide() {
    return {};
  },
  components: {
    MyTitle,
    Slogan,
    acPreviewFile,
  },
  computed: {
    ...mapGetters(["jcbqxwxxData", "jcbqccxsData", "jcbqzjxxData"]),
  },
  methods: {
    //点击导航
    changeNav(navIndex) {
      this.active = navIndex;
    },
    getData() {
      getJcbqScclList({ jbid: this.cId }).then((res) => {
        console.log(res.data);
        this.sqsclList = res.data.sqs;
        this.sqsclListQtcl = res.data.qt;
      });
      getJcbqxx({ id: this.cId })
        .then((res) => {
          console.log("获取基本信息", res.data);
          res.data.cJcbqsy = typeJcbqsy(res.data.cJcbqsy)
          res.data.dtCreatetime = this.timeFormat(res.data.dtCreatetime);
          res.data.cTjrsf=typeTjrlx(res.data.cTjrsf);
          res.data.cBz = res.data.cBz ? res.data.cBz : "--";
          Object.assign(this.jcbqjbxxData, res.data);
          if (this.jcbqjbxxData.nBqlx === 1) {
            this.$store
              .dispatch("GetJCBQCCXSList", { jbid: this.cId, bqid: "" })
              .then((res) => {
                res.data.map(function (item) {
                  item.cCclx = typeCclx(item.cCclx);
                });
              });
          } else if (this.jcbqjbxxData.nBqlx === 2) {
            this.$store
              .dispatch("GetJCBQZJXXList", { jbid: this.cId, bqid: "" })
              .then((res) => {
                res.data.map(function (item) {
                  item.nZjlx = zjlxType(item.nZjlx);
                });
              });
          } else if (this.jcbqjbxxData.nBqlx === 3) {
            this.$store
              .dispatch("GetJCBQXWXXList", { jbid: this.cId, bqid: "" })
              .then((res) => {
                res.data.map(function (item) {
                  item.nXwbqsx = xwsxType(item.nXwbqsx);
                });
              });
          }
        })
        .catch((error) => console.log(error));
      // 获取财产线索列表，详情页面根据jbid查询线索
      // this.$store.dispatch('GetJCBQCCXSList', {jbid:this.$route.params.id.split('-')[0],bqid:''})
    },
    timeFormat(currentTime) {
      // 时间格式化 2019-09-08
      let time = new Date(currentTime);
      let year = time.getFullYear();
      let month = this.showTime(time.getMonth() + 1);
      let day = this.showTime(time.getDate());
      return year + "-" + month + "-" + day;
    },
    // 封装一个不够两位数就补零的函数
    showTime(t) {
      let time;
      time = t >= 10 ? t : "0" + t;
      return time;
    },
    goToScxxDeatil: function (xwxxItem, cId, index) {
      // sessionStorage.setItem("jcxwxxItem", JSON.stringify(xwxxItem));
      // sessionStorage.setItem("bqXwxxId", cId);
      this.$router.push({
        path: "/JcscxxDeatil",
        query: {
          cId: this.cId,
          index: index,
          nBqlx: this.jcbqjbxxData.nBqlx,
        },
      });
    },
  },
  created() {
    // this.cBqlx=this.$route.query.bqlx;
    this.getData();

    // this.jcbqzjxxData.nZjlx = zjlxType(this.jcbqzjxxData.nZjlx)
  },
};
</script>

<style lang="less" scoped>
.guarantee-detail {
  .fd-upload-wrap {
    background-color: #fff;
  }
  .fd-nav {
    width: 100%;
    box-sizing: border-box;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    background: #ffff;

    > span {
      font-size: 14px;
      color: #666666;
    }

    .span-active {
      color: #0683fc;
      cursor: pointer;
    }
  }
}
</style>
